import React, { FunctionComponent, useState } from 'react';
import { makeStyles, createStyles, Box, Grid } from '@material-ui/core';
import Loader from '../../../../components/Loader';
import { CommentList } from '../../../../store/modules/application/types';
import AddCommentField from '../../../../components/AddCommentField';
import EmptyRecord from '../../../../components/TableView/TableEmptyState';
import CommentInfiniteScroll from '../../../../components/CommentInfiniteScroll';
import { Citation } from '../../../../store/modules/citation/types';

type CitationCommentProps = {
    addCitationComment: Function;
    loading: Boolean;
    citationCommentList: CommentList;
    citationDetails: Citation;
    skip: number;
    setSkip: Function;
    hasMore: boolean;
    doShowDetail: boolean;
};

const CitationComment: FunctionComponent<CitationCommentProps> = (props) => {
    const {
        addCitationComment,
        loading,
        citationCommentList,
        citationDetails,
        hasMore,
        skip,
        setSkip,
        doShowDetail,
    } = props;

    const useStyles = makeStyles(() =>
        createStyles({
            addCitationCommentDialog: {
                display: 'flex',
                flexGrow: 1,
                background: '#ffffff',
                width: '75%',
                padding: '25px',
                borderRadius: '5px',
                boxShadow:
                    '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
                marginLeft: 'auto',
                marginRight: 'auto',
                height: '100%',
                overflow: 'hidden',
            },
            comments: {
                width: '100%',
                marginTop: '40px',
            },
        }),
    );
    const classes = useStyles();
    const [isAddCitationCommentOpen, setAddCitationCommentOpen] = useState<boolean>(false);
    const [comment, setComment] = useState<string>('');
    const handleChangeComment = (event: React.ChangeEvent<{ name?: string; value: string }>) => {
        setComment(event.target.value);
    };

    const handleAddCitationCommentChange = () => {
        addCitationComment(comment, citationDetails?.id);
        setComment('');
        setAddCitationCommentOpen(false);
    };

    const loadMore = () => {
        if (hasMore) {
            setSkip(skip + 1);
        }
    };

    if (loading) {
        return <Loader />;
    }
    return (
        <Box className={classes.addCitationCommentDialog}>
            <Grid container className="verticalFillContainer">
                <AddCommentField
                    isAddCommentFieldOpen={isAddCitationCommentOpen}
                    setAddCommentFieldOpen={setAddCitationCommentOpen}
                    setComment={setComment}
                    handleAddCommentChange={handleAddCitationCommentChange}
                    handleChangeComment={handleChangeComment}
                    disabled={!!comment ? false : true}
                />
                <Box className={`${classes.comments} verticalFillContent`}>
                    {citationCommentList && citationCommentList.length > 0 ? (
                        <CommentInfiniteScroll
                            loadMore={loadMore}
                            hasMore={hasMore}
                            data={citationCommentList}
                            scrollableTarget="citationComment"
                            doShowDetail={doShowDetail}
                        />
                    ) : (
                        <Box>
                            <EmptyRecord title="No active records for this citation." message=" " />
                        </Box>
                    )}
                </Box>
            </Grid>
        </Box>
    );
};

export default CitationComment;
